import { SWRConfig, SWRConfiguration } from 'swr';
import { useToast } from '@/shared/providers/toast-provider/ToastProvider';
import { ReactNode } from 'react';

export const SwrProvider = ({ children }: { children: ReactNode }) => {
  const { showErrorToast } = useToast();

  const swrConfig: SWRConfiguration = {
    revalidateIfStale: false,
    revalidateOnFocus: false,
    revalidateOnReconnect: false,
    onError: (error) => {
      if (error.status) {
        showErrorToast(error);
      }
    },
  };

  return <SWRConfig value={swrConfig}>{children}</SWRConfig>;
};
